import { render, staticRenderFns } from "./CompanyNewsDetails.vue?vue&type=template&id=172930c4&scoped=true&"
import script from "./CompanyNewsDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNewsDetails.vue?vue&type=style&index=0&id=172930c4&scoped=true&lang=less&"
import style1 from "./CompanyNewsDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172930c4",
  null
  
)

export default component.exports